import { Box } from '@mantine/core';
import { FC } from 'react';
import SimpleTable from '@/PageComponents/SimpleTable/SimpleTable';
import time from '@/utils/time';
import { IconCheck } from '@tabler/icons-react';

const MessageReplyTable: FC<{
    replies: any[]
}> = (props: any) => {
    
    
    return (<>
        
        <Box p={'sm'}>
                <SimpleTable
                    stylingProps={{ compact: false, darkerText: true, rows: false }}
                    data={props.replies}
                    height={'100%'}
                    canEdit={true}
                    mapping={[
                        {
                            label: 'Customer',
                            key: 'CustomerName',
                            linkHrefFunction: (item: any) => {
                                return `/customer/${item.CustomerID}`;
                            },
                        },
                        {
                            label: 'Contact',
                            key: 'CustomerContactFullName'
                        },
                        {
                            label: 'Number',
                            key: 'SenderDetail',
                        },
                        {
                            label: 'Received',
                            key: 'ReceivedDateTime',
                            valueFunction: (item: any) => {
                                return `${time.formatDate(time.parseDate(item.ReceivedDateTime))}, ${time.getTimeFormatted(time.parseDate(item.ReceivedDateTime), 'hh:mm')}`;
                            }
                        },
                        {
                            label: 'Opted Out',
                            key: 'IsOptOut',
                            valueFunction: (item: any) => {
                                return item.IsOptOut ? <><IconCheck height={16} /></> : <></>;
                            }
                        },
                        {
                            label: 'Response',
                            key: 'Body'
                        }
                    ]}
                    tableItemInputMetadataByKeyName={{}}
                    controls={[]}
                    tableActionStates={{}}
                    showControlsOnHover={false}
                />
            </Box>
        
        <style jsx>{`
            
        `}</style>
    </>);
};

export default MessageReplyTable;